import * as React from 'react';
import { Box } from '@mui/material';

const PageLayout = ({ children }) => {
  return <Box>{children}</Box>;
};

export default PageLayout;
